import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { CopyOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';

interface IProps {
  text: string;
  style?: any;
  multiline?: boolean;
  disableUnderline?: boolean;
  fullWidth?: boolean;
  label?: string;
  id?: string;
  disabled?: boolean;
  hideInput?: boolean;
  onCopy?(text: string, result: boolean): void;
}

type CopyButtonProps = {
  text: string;
  disabled?: boolean;
  fallback?(text: string, result: boolean): void;
};

function CopyButton({ text, disabled, fallback }: CopyButtonProps) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipText, setTooltipText] = useState('Copiar');

  const handleTooltipClose = () => setTooltipOpen(false);
  const handleTooltipOpen = () => setTooltipOpen(true);

  const handleCopy = (copiedText: string, result: boolean) => {
    handleTooltipOpen();
    setTooltipText('Copiado');

    if (fallback) {
      fallback(copiedText, result);
    }

    setTimeout(() => {
      handleTooltipClose();
      setTooltipText('Copiar');
    }, 3000);
  };

  return (
    <Tooltip title={tooltipText} open={tooltipOpen} placement='top'>
      <span onMouseEnter={handleTooltipOpen} onMouseLeave={handleTooltipClose}>
        <CopyToClipboard text={text} onCopy={handleCopy}>
          <Button
            type='text'
            size='small'
            disabled={disabled}
            className='h-auto! w-auto! p-0!'
            icon={<CopyOutlined />}
          />
        </CopyToClipboard>
      </span>
    </Tooltip>
  );
}

const CustomCopyToClipboard: React.FC<IProps> = ({
  text,
  style,
  multiline,
  fullWidth,
  label,
  id,
  disabled,
  hideInput,
  onCopy
}) => {
  if (hideInput) {
    return (
      <div
        id={id}
        className='relative flex py-2 [&_button]:p-0 [&>div]:ml-4 [&>div]:h-[unset] [&>div]:min-w-[unset] [&>div]:border-none [&>div]:p-0'
        style={style}
      >
        {label ? <small>{label}</small> : ''}
        {text}
        <CopyButton text={text} fallback={onCopy} />
      </div>
    );
  }

  return (
    <div id={id} style={style} className={fullWidth ? 'w-full' : undefined}>
      {label && <label className='mb-1 block text-sm text-gray-600'>{label}</label>}
      {multiline ? (
        <Input.TextArea
          value={text}
          readOnly
          disabled={disabled}
          className={fullWidth ? 'w-full' : undefined}
          autoSize={{ minRows: 2 }}
        />
      ) : (
        <Input
          value={text}
          readOnly
          disabled={disabled}
          className={fullWidth ? 'w-full' : undefined}
          suffix={<CopyButton text={text} fallback={onCopy} />}
        />
      )}
    </div>
  );
};

export default CustomCopyToClipboard;
